import {
  PreviewWrapper,
  HeaderSection,
  HeadingContainer,
  HeadingTitle,
  ContentBody,
  ScanBottomSection,
  NotFoundErrorText,
  NotFoundDescription,
  NotFoundContentBox,
} from "../share/styled"
import { useLogMealStep } from "features/meal/hooks"
import Button from "components/Buttons/Button"
import ScanFailedPhoto from "../share/ScanFailedPhoto"
import ScanFailedBottomActions from "../share/ScanFailedBottomActions"
import Header from "../share/Header"
import { useLayoutEffect, useState } from "react"
import { PreviewImageSize } from "features/meal/mealSlice.types"

const NotFound = () => {
  const setStep = useLogMealStep()

  const handleRetakePhoto = () => {
    setStep("take-photo")
  }

  const [imageSize, setImageSize] = useState<PreviewImageSize>("normal")

  useLayoutEffect(() => {
    if (window.innerHeight <= 700) {
      setImageSize("small")
    }
  }, [])

  return (
    <PreviewWrapper>
      <Header />

      <HeaderSection>
        <HeadingContainer>
          <HeadingTitle>Photo Uploaded</HeadingTitle>
        </HeadingContainer>
      </HeaderSection>

      {/* Content Body */}
      <ContentBody>
        <ScanBottomSection>
          <ScanFailedPhoto imageSize={imageSize} />

          <NotFoundContentBox>
            <NotFoundErrorText>Not found</NotFoundErrorText>
            <NotFoundDescription>
              We couldn't detect any food or nutritional
            </NotFoundDescription>
            <NotFoundDescription>
              details in the photo. Please try again with a
            </NotFoundDescription>
            <NotFoundDescription>
              clearer image of your meal or nutrition label
            </NotFoundDescription>

            <Button
              $borderLess
              style={{ width: 143, alignSelf: "center", marginTop: 16 }}
              onClick={handleRetakePhoto}
              $type="primary"
            >
              Retry
            </Button>
          </NotFoundContentBox>
        </ScanBottomSection>
      </ContentBody>

      <ScanFailedBottomActions />
    </PreviewWrapper>
  )
}

export default NotFound
